
/**
 * js解析
 */ import GoingUtils from "@/utils/goingUtils";
import {StorageUtils} from 'xmgoing-utils';

/**
 * 解码设计信息/事件脚本中的 HTML 实体（部件接口返回的内容可能含 &gt; 等编码）
 */
export function decodeJsContentStr(content: string): string {
  if (!content || typeof content !== 'string') {
    return content;
  }
  return content
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

const jsParse = {
  /**
   * 全局最外层的js代码
   * @param funContent
   * @constructor
   */
  NewPublicFunction(funContent: string) {
    window.GoingUtils=GoingUtils;
    window.StorageUtils=StorageUtils;
    try {
      funContent = decodeJsContentStr(funContent);
      const fun = new Function("viewModel","inParams", `return ${funContent};`);
      return fun;
    }catch (e){
      console.error(e,'=========NewPublicFunction========', funContent)
    }

  },
  /**
   * 创建同步函数
   * @constructor
   */
  NewFunction(funContent: string) {
    window.GoingUtils=GoingUtils;
    window.StorageUtils=StorageUtils;
    console.log(funContent,"----NewFunction--funContent")
    try {
      funContent = decodeJsContentStr(funContent);
      const fun = new Function("viewModel", "inParams",`return ${funContent};`);
      return fun;
    }catch (e){
      console.error(e,'=========NewPublicFunction========', funContent)
    }
  }
}

export default jsParse;
